import { useQuery, requestDeals } from '@workspace/api';

export interface Courtier {
    cb: string;
    rs: string;
    cp: string;
}

export interface CourtierLinks {
    all: string;
    velo: string;
    trottinette: string;
    livraison: string;
}

export function useCourtiers() {
    return useQuery<{ data: Courtier[] }>({
        queryKey: ['deals', 'courtiers'],
        queryFn: async () => {
            const response = await requestDeals.get<{ data: Courtier[] }>('/api/courtiers');
            return response.data;
        },
        staleTime: 24 * 60 * 60 * 1000,
        gcTime: 24 * 60 * 60 * 1000,
    });
}

export function useCourtierLinks(id: string | null) {
    return useQuery<{ data: CourtierLinks }>({
        queryKey: ['deals', 'courtiers', id, 'links'],
        queryFn: async () => {
            const response = await requestDeals.get<{ data: CourtierLinks }>(`/api/courtiers/${id}/links`);
            return response.data;
        },
        enabled: !!id,
    });
}
